import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Data } from '@angular/router';
import produce from 'immer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { PatrolGroupService } from '../../../service/patrol-group.service';
import { EquipmentService } from '../../../service/equipment.service';
import { PatrolAreaService } from '../../../service/patrol-area.service';

@Component({
  selector: 'app-facility-group-equipment',
  templateUrl: './facility-group-equipment.component.html',
  styleUrls: ['./facility-group-equipment.component.less']
})
export class FacilityGroupEquipmentComponent implements OnInit {

  @Input() data: any; // data为选中的物资组数据

  validateForm: FormGroup;
  // 右侧列表参数
  pageIndexRight: number;
  pageSizeRight: number;
  totalRight = 0;
  listOfDataRight = [];
  startRowRight: number;
  loadingRight = true;
  listOfCurrentPageDataRight: Data[] = []; //
  checkedRight = false;
  listOfDisplayDataRight = [];
  listOfBatchDataRight = [];
  isAllDisplayDataCheckedRight = false;
  isIndeterminateRight = false;
  mapOfCheckedIdRight: { [key: string]: boolean } = {};
  listOfSelectionRight = [
    {
      text: '全选',
      onSelect: () => {
        this.checkAllRight(true);
      }
    }
  ];
  // 组类型
  groupType = '';
  // 左侧列表参数
  pageIndexLeft: number;
  pageSizeLeft: number;
  totalLeft = 0;
  listOfDataLeft = [];
  listOfDataLeftBak = [];
  startRowLeft: number;
  loadingLeft = true;
  listOfCurrentPageDataLeft: Data[] = [];
  checkedLeft = false;
  listOfDisplayDataLeft = [];
  listOfBatchDataLeft = [];
  isAllDisplayDataCheckedLeft = false;
  isIndeterminateLeft = false;
  mapOfCheckedIdLeft: { [key: string]: boolean } = {};
  listOfSelectionLeft = [
    {
      text: '全选',
      onSelect: () => {
        this.checkAllLeft(true);
      }
    }
  ];

  indeterminate = false;
  setOfCheckedId = new Set<number>();
  setOfCheckedItem = new Set<Data>();

  facilityTypes = [];
  facilitySubtypes = [];
  facilitySubtypesBak = [];

  constructor(
    private fb: FormBuilder,
    private groupService: PatrolGroupService,
    private equipmentService: EquipmentService,
    private patrolAreaService: PatrolAreaService,
    public message: NzMessageService,
    private modal: NzModalService,
    private modalRef: NzModalRef,
  ) {
    this.startRowRight = 1;
    this.pageIndexRight = 1;
    this.pageSizeRight = 10;
    this.startRowLeft = 1;
    this.pageIndexLeft = 1;
    this.pageSizeLeft = 10;
  }

  ngOnInit(): void {
    this.groupType = this.data.groupType;
    this.validateForm = this.fb.group({
      equipmentId: null,
      areaNo: null,
      equipmentName: null,
      areaName: null,
      typeId: null,
      subtypeId: null });
    this.getEquipmentMaintainData();
    this.queryEpListDataRight(1);
    this.queryEpListDataLeft(1);
    // this.listOfDataLeftBak = this.listOfDataLeft;
  }

  submitForm() {
    this.queryEpListDataRight(1);
  }

  resetForm() {
    this.validateForm.setValue({
      equipmentId: null,
      areaNo: null,
      equipmentName: null,
      areaName: null,
      typeId: null,
      subtypeId: null });
    this.queryEpListDataRight(1);
  }

  cancelUpdate(){
    this.modalRef.destroy();
  }

  submitUpdate(){
    const request = {
      groupId: this.data.groupId,
      leftData: this.listOfDataLeft,
      leftDataBak: this.listOfDataLeftBak,
      groupType : this.data.groupType
    };
    this.groupService.updateItemsInGroup(request).subscribe((response: any) => {
      if (response.code === 200) {
        this.modal.success({
          nzTitle: '巡检组管理',
          nzContent: `更新巡检组完成！`
        });
        this.modalRef.destroy();
      }else {
        this.modal.error({
          nzTitle: '巡检组管理',
          nzContent: `更新巡检组失败！`
        });
      }
    });
  }

  deleteRowsFromLeft(): void {
    if (this.data.groupType === '0'){
      const updatedListOfData = produce(this.listOfDataLeft, draft => {
        return draft.filter(item => !this.mapOfCheckedIdLeft[item.epNo]);
      });
      this.listOfDataLeft = updatedListOfData;
      this.mapOfCheckedIdLeft = {};
      this.isAllDisplayDataCheckedLeft = false;
      this.isIndeterminateLeft = false;
    }else{
        const updatedListOfData = produce(this.listOfDataLeft, draft => {
          return draft.filter(item => !this.mapOfCheckedIdLeft[item.areaNo]);
        });
        this.listOfDataLeft = updatedListOfData;
        this.mapOfCheckedIdLeft = {};
        this.isAllDisplayDataCheckedLeft = false;
        this.isIndeterminateLeft = false;
      }
  }
  addRowsToLeft(): void {
    if (this.data.groupType === '0' ){
      const updatedListOfData = produce(this.listOfDataRight, draft => {
        return draft.filter(item => this.mapOfCheckedIdRight[item.epNo]);
      });
      // tslint:disable-next-line:prefer-for-of
      if ( updatedListOfData.length > 0){
        const ls = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < updatedListOfData.length; i++) {
          const bExist = this.listOfDataLeft.some(item => item.epNo === updatedListOfData[i].epNo);
          if (!bExist) {
            ls.push(
              {
                epName: updatedListOfData[i].epName,
                epNo: updatedListOfData[i].epNo,
                id: updatedListOfData[i].id,
                storeLocation: updatedListOfData[i].storeLocation,
              }
            );
          }
        }
        this.listOfDataLeft = [...ls, ...this.listOfDataLeft];
      }
      // for (let i = 0; i < updatedListOfData.length; i++) {
      //   const bExist = this.listOfDataLeft.some(item => item.epNo === updatedListOfData[i].epNo);
      //   if (!bExist) {
      //     // this.listOfDataLeft = [...this.listOfDataLeft,
      //     // {
      //     //   epName: updatedListOfData[i].epName,
      //     //   epNo: updatedListOfData[i].epNo,
      //     //   id: updatedListOfData[i].id,
      //     //   storeLocation: updatedListOfData[i].storeLocation,
      //     // }];
      //   }
      // }
    }
    if (this.data.groupType === '1' ){
      const updatedListOfData = produce(this.listOfDataRight, draft => {
        return draft.filter(item => this.mapOfCheckedIdRight[item.areaNo]);
      });
      if ( updatedListOfData.length > 0){
        const ls = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < updatedListOfData.length; i++) {
          const bExist = this.listOfDataLeft.some(item => item.areaNo === updatedListOfData[i].areaNo);
          if (!bExist) {
            ls.push(
              {
                areaName: updatedListOfData[i].areaName,
                areaNo: updatedListOfData[i].areaNo,
                areaId: updatedListOfData[i].areaId,
                locationName: updatedListOfData[i].locationName
              }
            );
          }
        }
        this.listOfDataLeft = [...ls, ...this.listOfDataLeft];
      }
      // tslint:disable-next-line:prefer-for-of
      // for (let i = 0; i < updatedListOfData.length; i++) {
      //   const bExist = this.listOfDataLeft.some(item => item.areaNo === updatedListOfData[i].areaNo);
      //   if (!bExist) {
      //     // this.listOfDataLeft = [...this.listOfDataLeft,
      //     // {
      //     //   areaName: updatedListOfData[i].areaName,
      //     //   areaNo: updatedListOfData[i].areaNo,
      //     //   areaId: updatedListOfData[i].areaId
      //     // }];
      //   }
      // }
    }
  }

  checkAllRight(value: boolean): void {
    if (this.data.groupType === '0' ){
      this.listOfDataRight.forEach(item => (this.mapOfCheckedIdRight[item.epNo] = value));
    }
    if (this.data.groupType === '1' ){
      this.listOfDataRight.forEach(item => (this.mapOfCheckedIdRight[item.areaNo] = value));
    }
    this.refreshStatusRight();
  }
  checkAllLeft(value: boolean): void {
    if (this.data.groupType === '0' ){
      this.listOfDataLeft.forEach(item => (this.mapOfCheckedIdLeft[item.epNo] = value));
    }
    if (this.data.groupType === '1' ){
      this.listOfDataLeft.forEach(item => (this.mapOfCheckedIdLeft[item.areaNo] = value));
    }
    this.refreshStatusLeft();
  }

  onPageIndexChangeRight(pageIndex): void {
    this.pageIndexRight = pageIndex;
    this.queryEpListDataRight(2);
  }
  currentPageDataChangeRight($event: []): void {
    this.listOfDisplayDataRight = $event;
    this.refreshStatusRight();
  }
  refreshStatusRight(): void {
    if ( this.data.groupType === '0' ){
      this.isAllDisplayDataCheckedRight = this.listOfDisplayDataRight.every(item => this.mapOfCheckedIdRight[item.epNo]);
      // tslint:disable-next-line:max-line-length
      this.isIndeterminateRight = this.listOfDisplayDataRight.some(item => this.mapOfCheckedIdRight[item.epNo]) && !this.isAllDisplayDataCheckedRight;
      this.listOfBatchDataRight = this.listOfDataRight.filter(item => this.mapOfCheckedIdRight[item.epNo]);
    }
    if ( this.data.groupType === '1'){
      this.isAllDisplayDataCheckedRight = this.listOfDisplayDataRight.every(item => this.mapOfCheckedIdRight[item.areaNo]);
      // tslint:disable-next-line:max-line-length
      this.isIndeterminateRight = this.listOfDisplayDataRight.some(item => this.mapOfCheckedIdRight[item.areaNo]) && !this.isAllDisplayDataCheckedRight;
      this.listOfBatchDataRight = this.listOfDataRight.filter(item => this.mapOfCheckedIdRight[item.areaNo]);
    }

  }
  onPageIndexChangeLeft(pageIndex): void {
    this.pageIndexLeft = pageIndex;
    // this.queryEpListDataLeft(2);
  }
  currentPageDataChangeLeft($event: []): void {
    this.listOfDisplayDataLeft = $event;
    this.refreshStatusLeft();
  }
  refreshStatusLeft(): void {
    if ( this.data.groupType === '0' ){
      this.isAllDisplayDataCheckedLeft = this.listOfDisplayDataLeft.every(item => this.mapOfCheckedIdLeft[item.epNo]);
      // tslint:disable-next-line:max-line-length
      this.isIndeterminateLeft = this.listOfDisplayDataLeft.some(item => this.mapOfCheckedIdLeft[item.epNo]) && !this.isAllDisplayDataCheckedLeft;
      this.listOfBatchDataLeft = this.listOfDataLeft.filter(item => this.mapOfCheckedIdLeft[item.epNo]);
    }
    if ( this.data.groupType === '1'){
      this.isAllDisplayDataCheckedLeft = this.listOfDisplayDataLeft.every(item => this.mapOfCheckedIdLeft[item.areaNo]);
      // tslint:disable-next-line:max-line-length
      this.isIndeterminateLeft = this.listOfDisplayDataLeft.some(item => this.mapOfCheckedIdLeft[item.areaNo]) && !this.isAllDisplayDataCheckedLeft;
      this.listOfBatchDataLeft = this.listOfDataLeft.filter(item => this.mapOfCheckedIdLeft[item.areaNo]);
    }
  }

  /**
   *  查询右侧物资数据
   *   @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryEpListDataRight(flag: number) {
    if (flag === 1) {
      this.pageIndexRight = 1;
      this.pageSizeRight = 10;
    }
    // tslint:disable-next-line:max-line-length
    if (this.data.groupType === '0'){
      // tslint:disable-next-line:max-line-length
      const result = await this.equipmentService.getAllEquipmentsListByCondition(this.validateForm.value, this.pageIndexRight, this.pageSizeRight);
      if (result === null) {
        this.message.create('error', '资产数据查询失败!');
        return;
      } else {
        this.loadingRight = false;
        this.listOfDataRight = result.list;
        this.totalRight = result.total;
        this.startRowRight = result.startRow;
      }
    }else{
      // tslint:disable-next-line:max-line-length
      const result = await this.patrolAreaService.getPatrolAreasByCondition(this.validateForm.value, this.pageIndexRight, this.pageSizeRight);
      if (result === null) {
        this.message.create('error', '区域数据查询失败!');
        return;
      } else {
        this.loadingRight = false;
        this.listOfDataRight = result.list;
        this.totalRight = result.total;
        this.startRowRight = result.startRow;
      }

    }
  }

  /**
   *  查询左侧物资数据
   *   @param flag 1表示点击搜索按钮，2表示翻页
   */
     async queryEpListDataLeft(flag: number) {
      if (flag === 1) {
        this.pageIndexLeft = 1;
        this.pageSizeLeft = 10;
      }
      // tslint:disable-next-line:max-line-length
      const result = await this.groupService.getAllItemsFromGroup(this.data.groupId, this.pageIndexLeft, this.pageSizeLeft, this.data.groupType);
      if (result.code !== 200) {
        this.message.create('error', '当前巡检组的巡检数据查询失败!');
        return;
      } else {
        this.loadingLeft = false;
        this.listOfDataLeft = result.data.list;
        if (flag === 1) {
          this.listOfDataLeftBak = result.data.list;
        }
        this.totalLeft = result.data.total;
        this.startRowLeft = result.data.startRow;
      }
    }

  /**
   * 查询物资维护数据
   */
  getEquipmentMaintainData(){
    this.equipmentService.getEquipmentMaintainData().subscribe((response: any) => {
      if (response.code === 200) {
        const allType = response.data.物资类型;
        for (const item of allType) {
          if (item.remark.length <= 3) {
            this.facilityTypes.push(item);
          } else {
            this.facilitySubtypes.push(item);
          }
        }
        this.facilitySubtypesBak = this.facilitySubtypes;
      } else {
        this.message.error('物资维护数据获取失败');
      }
    });
  }
  /**
   * 处理类型数据
   */
  typeChange(value: string): void {
    this.facilitySubtypes = this.facilitySubtypesBak;
    if (value === null) {
      return;
    }
    const subtypes = [];
    let valueCode = '';
    for (const item of this.facilityTypes){
      if (item.dictValue === value) {
        valueCode = item.remark;
      }
    }
    for (const element of this.facilitySubtypes){
      if (valueCode === element.remark.substring(0, 3)) {
        subtypes.push(element);
      }
    }
    this.facilitySubtypes = subtypes;
    this.validateForm.get('subtypeId').setValue('');
  }

}
